// extracted by mini-css-extract-plugin
export var alertIcon = "_te-0";